<avatar [user]="participant" [size]="size" [cornerRadius]="2"></avatar>
<svg-icon class="role-icon" [icon]="roleIcon"></svg-icon>
